<template>
  <div class="usermessage-container">
    <div class="tabbar-container">电子签名</div>
    <div class="message-container">
      <van-cell-group inset>
        <van-field readonly label="电子签名">
          <template #button>
            <van-button @click="showSign = true" size="small" type="primary">签名</van-button>
          </template>
        </van-field>
        <div class="sign-view" v-if="student.SignUrl"><van-image :src="student.SignUrl" /></div>
      </van-cell-group>
      <div class="checkout" @click="saveMessage">保存</div>
    </div>

    <van-popup v-model="showSign" @close="handleReset" round position="bottom">
      <div class="sign-container">
        <span>签名</span>
        <vue-esign style="border-radius: 15px; margin-top: 10px" ref="esign" :width="800" :height="450" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
        <div class="sign-button">
          <van-button size="small" style="margin-right: 10px" @click="handleReset" type="default">清空</van-button>
          <van-button size="small" @click="handleGenerate" type="info">确认</van-button>
        </div>
      </div>
    </van-popup>

    <van-overlay :show="addLoading" :custom-style="{ background: 'rgba(0,0,0,0.2)' }">
      <van-loading style="position: absolute; top: calc(50% - 25px); left: calc(50% - 30px)" size="50px" color="#0094ff" vertical text-color="#0094ff">加载中</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import vueEsign from "vue-esign";
export default {
  name: "Signature",
  components: { vueEsign },
  computed: {},
  data() {
    return {
      addLoading: false,
      student: {
        USER_ID: "",
        SignUrl: "",
      },

      showSign: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      isCrop: false,
    };
  },
  watch: {},
  created() {},
  async mounted() {
    this.student.USER_ID = this.getUrlParam("id");
  },
  destroyed() {},
  methods: {
    handleReset() {
      this.$refs.esign.reset();
    },
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then((res) => {
          this.student.SignUrl = res;
          this.showSign = false;
        })
        .catch(() => {
          this.$toast("请在签字版上签名后保存");
        });
    },
    async saveMessage() {
      if (!this.student.USER_ID) {
        this.$toast("未获取到用户信息\n请扫码重试");
        return;
      }
      if (!this.student.SignUrl) {
        this.$toast("请电子签名");
        return;
      }
      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 20000);

      const url = `api/EditSignUrl`;
      // 修改、保存
      this.$store
        .dispatch(url, this.student)
        .then((response) => {
          if (response.success) {
            this.addLoading = false;
            this.$toast("保存成功");
          } else {
            this.addLoading = false;
            this.$toast(response.message);
          }
        })
        .catch((error) => {
          this.addLoading = false;
          console.log(error);
        });
    },
    getUrlParam(name) {
      const url = window.location.href;
      const regex = new RegExp("[?&]" + name + "(=([^#&]*)|&|#|$)");
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
};
</script>

<style lang="scss" scoped>
.usermessage-container {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(#2d8efc, #1ccaa3);
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.tabbar-container {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 1rem;
  position: relative;
  font-size: 1.1rem;
}

.message-container {
  background: #ffffff;
  padding-top: 1rem;
  border-radius: 10px;
  margin-top: 1rem;
  width: 90%;
}

.checkout {
  width: 90%;
  height: 44px;
  margin-left: 5%;
  margin-top: 1rem;
  border-radius: 999px;
  margin-bottom: 1rem;
  display: flex;
  align-items: row;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(270deg, #2d8efc, #1ccaa3);
  color: #ffffff;
  font-size: 1rem;
}

/deep/ .van-cell-group--inset {
  margin: 0;
}

/deep/ .van-cell {
  width: 100% !important;
  margin: 0 !important;
}

.sign-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;

  .sign-button {
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.sign-view {
  padding: 15px;
  box-sizing: border-box;
}
</style>
